import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AddFieldPage } from './add-field.page';

const routes: Routes = [
  {
    path: '',
    component: AddFieldPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AddFieldPageRoutingModule {}
